import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Dropdown } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { UserValidateFields } from '../validate/userValidation';
import ErrorFilter from '../../helper/errorFilter';
import { requestHandler } from '../../helper';
import { editUser } from '../../controller';
import { toast } from 'react-toastify';
import SingleError from '../../helper/SingleError';


function UserEdit({ id, userData, getAllUsers }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);

    const requireField = [
        "userName",
        "email",
    ];
    const [formData, setFormData] = useState({
        userName: '',
        email: '',
        password: '',
        confirmPassword: '',
        isPremium: false,
        plan: null,
        status: true
    });


    const handleShow = () => {
        setShow(true);
        handleEditUser(id);
    };

    const handleEditUser = async (id) => {
        const user = userData.find(user => user._id === id);
        setFormData({
            userName: user.userName,
            email: user.email,
            password: user.password,
            confirmPassword: user.password,
            isPremium: user.isPremium,
            plan: user.plan,
            status: user.status
        })

    }

    const handleChange = async (e) => {
        const { name, value, checked, type } = e.target;
        let newValue = type === "checkbox" ? checked : value;
        if (submitCount > 0) {
            let validationErrors = UserValidateFields({ ...formData, [name]: value });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...formData };
        delete updatedValues.confirmPassword;
        delete updatedValues.password;

        let validationErrors = UserValidateFields(updatedValues);
        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            if (updatedValues.plan === null) {
                delete updatedValues.plan
            }
            await requestHandler(
                async () => await editUser(updatedValues, id),
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose(); // Optionally close the modal upon success
                    // Clear the form or reset userData if needed
                    setFormData({
                        userName: '',
                        email: '',
                        isPremium: false,
                        plan: null,
                        status: true
                    });
                    getAllUsers();
                },
                () => { }
            )

        }

    }

    return (
        <>

            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/edit2.png" alt="" />
                </button>
            </OverlayTrigger>


            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Edit User</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter User" name="userName" value={formData.userName} onChange={handleChange} />
                                <SingleError error={errors?.userName} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control type="text" placeholder="Enter E-mail" name='email' value={formData.email} onChange={handleChange} />
                                <SingleError error={errors?.email} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Premium</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle>
                                        {formData.isPremium ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, isPremium: false })}>Deactive</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, isPremium: true })}>Active</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Plan</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success">
                                        {formData.plan || 'Select Plan'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, plan: 'MONTHLY' })}>Monthly</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, plan: 'YEARLY' })}>Yearly</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, plan: 'ONE_TIME' })}>One Time</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle>
                                        {formData.status ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, status: true })}>Active</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, status: false })}>Deactive</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Update</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserEdit